import React from "react";
import BreadCrumb from "common/breadcrumb";
import DefaultTabs from "./default-tabs";
import PillsJustified from "./pills-justified";
import SimpleBorder from "./simple-border";
import IconArrow from "./icon-arrow";
import VerticalTabs from "./certical-tabs";

const NavTabs = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Tabs" pageTitle="Navigation" />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-2">
                    <DefaultTabs />
                    <PillsJustified />
                    <SimpleBorder />
                    <IconArrow />
                    <VerticalTabs />
                </div>
            </div>
        </React.Fragment>
    );
}

export default NavTabs;